import { db } from '../firebase';
import { collection, getDocs, addDoc, updateDoc, deleteDoc, doc, query, where, orderBy, getDoc } from 'firebase/firestore';
import { getCurrentUserPermission, getEffectiveUserId } from './userService';

const ideasCollection = collection(db, "ideas");

// Vérifie la permission "ideas" de l'utilisateur courant
async function assertIdeasAccess() {
  const perm = await getCurrentUserPermission("ideas");
  return perm !== "none";
}

// Récupère toutes les idées de l'utilisateur effectif
export const fetchIdeas = async () => {
  if (!(await assertIdeasAccess())) return [];
  const userId = await getEffectiveUserId();
  const ideasQuery = query(ideasCollection, where("userId", "==", userId), orderBy("order"));
  const querySnapshot = await getDocs(ideasQuery);
  return querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })) || [];
};

export const getIdeaById = async (id) => {
  if (!(await assertIdeasAccess())) return null;
  const ideaRef = doc(db, "ideas", id);
  const ideaDoc = await getDoc(ideaRef);
  if (ideaDoc.exists()) {
    return { id: ideaDoc.id, ...ideaDoc.data() };
  } else {
    throw new Error("Idea not found");
  }
};

export const addIdea = async (idea) => {
  if (!(await assertIdeasAccess())) return null;
  if (!idea) return;
  const userId = await getEffectiveUserId();
  const ideas = await fetchIdeas();
  const newOrder = ideas.length > 0 ? ideas[ideas.length - 1].order + 1 : 0;
  const newIdea = { ...idea, userId, order: newOrder };
  const docRef = await addDoc(ideasCollection, newIdea);
  return { id: docRef.id, ...newIdea };
};

export const updateIdea = async (idea) => {
  if (!(await assertIdeasAccess())) return;
  if (!idea.id) {
    throw new Error("Invalid idea ID. Cannot update idea without a valid ID.");
  }
  const ideaRef = doc(db, "ideas", idea.id);
  await updateDoc(ideaRef, { ...idea });
};

export const deleteIdea = async (ideaId) => {
  if (!(await assertIdeasAccess())) return;
  if (!ideaId) return;
  const ideaDoc = doc(db, "ideas", ideaId);
  await deleteDoc(ideaDoc);
};

export const updateAllIdeas = async () => {
  if (!(await assertIdeasAccess())) return;
  // 1. Récupère toutes les idées de l'utilisateur effectif
  const userId = await getEffectiveUserId();
  const snapshot = await getDocs(query(ideasCollection, where("userId", "==", userId), orderBy('order')));
  const ideas = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));

  // 2. Trie et met à jour 'order'
  const sortedIdeas = ideas.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  for (let idx = 0; idx < sortedIdeas.length; idx++) {
    const idea = sortedIdeas[idx];
    const ref = doc(ideasCollection, idea.id);
    await updateDoc(ref, { order: idx, priority: idea.priority || 0 });
  }
};